<template>
  <a-row class="container-fluid container-wrap col-sm-12 col-xs-12">
    <a-col :span="1"></a-col>
    <a-col class="justify-content-center" :span="22">
      <div style="margin-top: 28px"></div>
      <div class="card-header pb-0 col-sm-12 d-flex">
        <div class="col-sm-12 col-xs-12">
          <div class="col-sm-12 col-xs-12 justify-content-between titleContainer">
            <h3 class="title">{{ $t('navbar_event_list') }}</h3>
            <h5 class="desc">이벤트를 관리 할 수 있습니다.</h5>
          </div>
        </div>
      </div>
      <div class="card-body px-0 pt-0 pb-2 table-with-search">
        <div class="search-filter-container table-info-filter">
          <div class="search-filter-row">
            <div class="search-filter-title">
              검색어
            </div>
            <div class="search-filter-content">
              <div class="mobile-wrap">
                <a-select
                    size="small"
                    style="width: 150px"
                    v-model:value="searchFilter.keyword.option"
                    @change="v => searchFilter.keyword.option = v"
                >
                  <a-select-option value="이벤트명">
                    이벤트명
                  </a-select-option>
                </a-select>
                <a-input
                    size="small"
                    v-model:value="searchFilter.keyword.word"
                    @keyup.enter="async (event) => {
                      paginationData.currentPage = 1
                      await uiHandler.search();
                    }"
                    @focusin="e => searchFilter.keyword.word = ''"
                    :placeholder="$t('common_searchfilter_placeholder')"
                >
                  <template #prefix>
                    <i
                        class="fa-regular fa-magnifying-glass"
                    />
                  </template>
                </a-input>
              </div>
              <div class="mobile-wrap">
                <button
                    class="search-btn-filter"
                    @click="async (event) => {
                      paginationData.currentPage = 1
                      await uiHandler.search()
                    }"
                >
                  검색
                </button>
                <button
                    class="init-btn"
                    @click="event => {
                      searchFilter.keyword.option = '이벤트명'
                      searchFilter.keyword.word = ''
                      searchFilter.deptName = ''
                      dateRanges = []
                      searchFilter.eventStartDate = ''
                      searchFilter.eventEndDate = ''
                      paginationData.currentPage = 1
                      searchFilter.selectedDateFilter = 'all'
                      searchFilter.sort = {parameter: 'validationDate', method: 'descend'}
                      uiHandler.search()
                    }"
                >
                  초기화
                </button>
              </div>
            </div>
          </div>
          <div class="search-filter-row">
            <div class="search-filter-title">
              계약일
            </div>
            <div class="search-filter-content">
              <div class="date-filter-container-wrapper is-mobile-only">
                <div class="date-filter-container ">
                  <div
                      class="date-filter-item"
                      :class="searchFilter.selectedDateFilter === 'all' ? 'selected' : ''"
                      @click="async (e) => {
                        searchFilter.selectedDateFilter = 'all'
                        paginationData.currentPage = 1
                        await uiHandler.search()
                      }"
                  >
                    {{ $t('common_total') }}
                  </div>
                  <div
                      v-for="item in searchFilter.dateFilters.slice(0,1)"
                      class="date-filter-item"
                      :class="searchFilter.selectedDateFilter === item ? 'selected' : ''"
                      @click="async (e) => {
                        searchFilter.selectedDateFilter = item
                        paginationData.currentPage = 1
                        await uiHandler.search()
                      }"
                  >
                    {{
                      item === 'etc' ? $t('common_searchfilter_custom') : `${$t('common_searchfilter_recent')} ${uiHandler.convertMonthAndYearText(item)}`
                    }}
                  </div>
                </div>
                <div class="date-filter-container ">
                  <div
                      v-for="item in searchFilter.dateFilters.slice(1,3)"
                      class="date-filter-item"
                      :class="searchFilter.selectedDateFilter === item ? 'selected' : ''"
                      @click="async (e) => {
                        searchFilter.selectedDateFilter = item
                        paginationData.currentPage = 1
                        await uiHandler.search()
                      }"
                  >
                    {{
                      item === 'etc' ? $t('common_searchfilter_custom') : `${$t('common_searchfilter_recent')} ${uiHandler.convertMonthAndYearText(item)}`
                    }}
                  </div>
                </div>
                <div class="date-filter-container  " style="width: 100%;">
                  <div
                      v-for="item in searchFilter.dateFilters.slice(3,4)"
                      class="date-filter-item"
                      :class="searchFilter.selectedDateFilter === item ? 'selected' : ''"
                      style="width: 100%; border-bottom: 1px solid rgba(0, 0, 0, 0.15);"
                      @click="async (e) => {
                        searchFilter.selectedDateFilter = item
                        paginationData.currentPage = 1
                        await uiHandler.search()
                      }"
                  >
                    {{
                      item === 'etc' ? $t('common_searchfilter_custom') : `${$t('common_searchfilter_recent')} ${uiHandler.convertMonthAndYearText(item)}`
                    }}
                  </div>
                </div>
              </div>
              <div class="date-filter-container is-desktop-tablet">
                <div
                    class="date-filter-item"
                    :class="searchFilter.selectedDateFilter === 'all' ? 'selected' : ''"
                    @click="async (e) => {
                        searchFilter.selectedDateFilter = 'all'
                        paginationData.currentPage = 1
                        await uiHandler.search()
                      }"
                >
                  {{ $t('common_total') }}
                </div>
                <div
                    v-for="item in searchFilter.dateFilters"
                    class="date-filter-item"
                    :class="searchFilter.selectedDateFilter === item ? 'selected' : ''"
                    @click="async (e) => {
                        searchFilter.selectedDateFilter = item
                        paginationData.currentPage = 1
                        await uiHandler.search()
                      }"
                >
                  {{
                    item === 'etc' ? $t('common_searchfilter_custom') : `${$t('common_searchfilter_recent')} ${uiHandler.convertMonthAndYearText(item)}`
                  }}
                </div>
              </div>

              <div class="date-selector-container custom" v-if="searchFilter.selectedDateFilter === 'etc'">
                <a-range-picker
                    size="small"
                    :allowClear="false" :locale="locale" v-model:value="dateRanges"
                    @change="async (e) => {
                    searchFilter.selectedDateFilter = 'etc'
                    paginationData.currentPage = 1
                    await uiHandler.search()
                  }"
                    style="width: 250px;"/>
              </div>
            </div>
          </div>
          <div class="search-filter-row">
            <div class="search-filter-title">
              이벤트 상태
            </div>
            <div class="search-filter-content">
              <a-select
                  style="width: 150px; min-width: 100px"
                  v-model:value="searchFilter.status"
                  @change="(val) => uiHandler.search({status: val})"
                  size="small"
                  :options="statusList"
              />
            </div>
          </div>
        </div>
        <div class="col-xs-12 table-info-filter">
          <div class="total-div">
            <p>
              {{ $t('common_total') }}
              <span class="number-highlight">{{ formatCommaNumber(events.totalDocs) }}</span>
              {{ $t('common_case') }}
            </p>
          </div>
          <div class="search-container">
            <a-button
                @click="e => $router.push('/events/add')"
                type="primary"
                class="no-mobile"
            >
              <i class="fa-solid fa-plus"/>
              이벤트 등록하기
            </a-button>
            <a-select class="search-select" v-model:value="paginationData.rowsPerPage" style="width: 120px"
                      @change="uiHandler.search">
              <a-select-option :value="10" selected>10{{ $t('common_searchfilter_rowsperpage') }}</a-select-option>
              <a-select-option :value="20">20{{ $t('common_searchfilter_rowsperpage') }}</a-select-option>
              <a-select-option :value="50">50{{ $t('common_searchfilter_rowsperpage') }}</a-select-option>
            </a-select>
          </div>
        </div>
        <div class="card content-wrap-card col-sm-12 col-xs-12 tableCard p-0">
          <div class="table-responsive table-wrap table-relative">
            <div class="table-spinner-container" v-if="dataLoading">
              <div class="spinner"/>
            </div>
            <a-table class="ant-table-striped"
                     size="small"
                     bordered
                     :scroll="{ x: '2200px' }"
                     :columns="events.columns"
                     :data-source="events.list"
                     :pagination="false"
                     :showSorterTooltip="false"
                     @change="uiHandler.handleTableChange"
                     v-show="!dataLoading && events.list.length > 0"
            >
            </a-table>

            <div class="no-result-container" v-show="!dataLoading &&events.list.length ===  0">
              <i class="fa-solid fa-exclamation-triangle"/>
              <span v-if="!dataLoading">{{ computedNoResultMessage }} </span>
            </div>
          </div>
        </div>
      </div>
      <pagination
          v-if="!noResult"
          :page-info="paginationData"
          page-name="EventList"
          @change-page="async (childPassParam) => {
            paginationData.currentPage = childPassParam.page;
            await uiHandler.search()
          }"
      />
    </a-col>
    <a-col :span="1"></a-col>
  </a-row>
</template>
<script>
import Pagination from "@/views/components/Pagination.vue";
import eventApis from "@/views/EventManagement/api";
import {formatCommaNumber} from "@/utils/utils";
import dayjs from "dayjs";
import 'dayjs/locale/ko'
import locale from "ant-design-vue/es/date-picker/locale/ko_KR";

export default {
  components: {Pagination},
  computed: {
    noResult() {
      return !this.$store.state.isLoading && this.events.totalDocs === 0
    },
    computedNoResultMessage() {
      return this.$i18n.t('noresult_event');
    },
    statusList() {
      return [
        {label: '전체', value: '전체'},
        {label: '예정', value: '예정'},
        {label: '진행중', value: '진행중'},
        {label: '종료', value: '종료'},
      ]
    }
  },
  data() {
    return {
      uiHandler: this.ui(),
      apiHandler: this.api(),
      formatCommaNumber,
      dateRanges: [dayjs().startOf('month'), dayjs()],
      locale,
      dataLoading: false,
      modal: {
        createEvent: {
          show: false
        },
      },
      searchFilter: {
        keyword: {
          option: '이벤트명',
          word: ''
        },
        status: '전체',
        selectedDateFilter: 'all',
        dateFilters: [3, 12, 'etc'],
        startContractDate: '',
        endContractDate: '',
        sort: {
          parameter: 'validationDate',
          method: 'descend'
        }
      },
      paginationData: {
        listSize: 0,
        rowsPerPage: 10,
        currentPage: 1,
        totalPages: 1,
      },
      events: {
        totalDocs: 0,
        list: [],
        columns: [
          {key: 'index', title: '번호', dataIndex: 'index', align: 'center', fixed: 'left', width: '40px'},
        ]
      }
    }
  },
  methods: {
    ui() {
      return {
        search: async () => {
        },
        convertMonthAndYearText: (input) => {
          if (input < 12) return `${input}${this.$i18n.t('common_searchfilter_month')}`;
          return `${input / 12}${this.$i18n.t('common_searchfilter_year')}`;
        },
      }
    },
    api() {
      return eventApis(this.$apiInstance, this.$store)
    }
  }
}
</script>
<style scoped lang="scss">
.search-filter-content {
  .mobile-wrap {
    display: flex;
    gap: 8px;
  }

  .mobile-no-wrap {
    display: flex;
  }
}

@media screen and (max-width: 767px) {
  .date-selector-container,
  .ant-picker.ant-picker-range {
    width: 100% !important;
  }
  .search-filter-content .date-filter-container-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;

    .date-filter-container {
      flex-direction: row;
      border-radius: 0;
      border-bottom: 0;

      .date-filter-item {
        width: 50%;
        border-bottom: 0;
      }
    }
  }
  .container-fluid .row.justify-content-center {
    padding: 14px 14px 36px 14px !important;
  }
  .mainDiv {
    width: 100% !important;
  }
  .search-filter-title {
    margin-right: auto;
    width: auto;
    margin-left: 10px;
  }
  .search-filter-content .mobile-wrap {
    width: 100%;
  }
  .search-filter-content .search-select {
    width: 100px;
  }
  .search-filter-content .search-input-container {
    width: calc(100% - 100px);
    display: flex;
    justify-content: flex-start;

    input {
      width: 100%;
    }
  }
  .search-filter-content .date-filter-container {
    height: auto;
  }
  .search-filter-content .date-selector-container.custom {
    flex-direction: column;
    height: auto;
    align-items: center;
  }
  .search-filter-content .date-filter-container {
    flex-direction: column;
  }
  .search-filter-row {
    height: auto;
  }
  .search-filter-row,
  .search-filter-content {
    flex-direction: column;
    flex: none;
  }
  .card-header {
    margin: 0;
  }
}

@media screen and (min-width: 768px) and (max-width: 1023px) {
  .search-filter-title {
    width: 100%;
    justify-content: flex-start;
    margin-left: 20px;
  }
  .table-with-search .table-info-filter {
    flex-direction: column;
    width: 100%;

    .total-div {
      margin-right: auto;
    }

    .search-container {
      width: 100%;
      flex-direction: row;

      .search-select {
        margin-right: auto;
      }

      .search-div {
        flex-direction: row;
        width: 100%;

        input {
          width: calc(100% - 80px) !important;
        }

        .search-btn {
          min-width: 80px;
        }
      }
    }
  }
  .search-filter-row {
    flex-direction: column;
    height: auto;

    &:nth-of-type(2) {
      .search-filter-content {
        flex-direction: column;
      }

      .search-filter-content {
        align-items: flex-start;
      }

      .date-selector-container.custom {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
      }
    }
  }
}
</style>